module.exports = __webpack_public_path__ + "img/Notification.493cc540.svg";